import { type FC, useCallback } from 'react'

import { useUnit } from 'effector-react'
import { useMutation, useQueryClient } from 'react-query'

import { DIALOG_TYPE } from '@/dialogs/constants.ts'
import { $fanId, updateFanBirthday } from '@/models/chattingUI/chats/chats.ts'
import { $creatorId } from '@/models/creators.ts'
import { openDialog } from '@/models/dialogs.ts'
import { fanInfoService } from '@/modules/chatting/service/fan-info'
import { handleError } from '@/utils/error'

import EditIcon from '../../../../icons/edit.svg'
import { IconButton } from '../../../components/icon-button'

interface Props {}

export const EditBirthday: FC<Props> = () => {
  const creatorId = useUnit($creatorId)
  const fanId = useUnit($fanId)
  const queryClient = useQueryClient()
  const editBirthdayMutation = useMutation(
    (birthday: string) =>
      fanInfoService.editBirthday({
        creatorId: creatorId!,
        userId: fanId!,
        birthday,
      }),
    {
      onSuccess: (_, birthday) => {
        updateFanBirthday({ fanId, birthday })
        queryClient.invalidateQueries(['upcoming-birthdays', creatorId])
      },
      onError: (error) =>
        handleError(
          error,
          'Unexpected error occurred while update fans birthday, please try again later',
        ),
    },
  )

  const handleDialogOpen = useCallback(() => {
    openDialog({
      type: DIALOG_TYPE.BIRTHDAY_EDIT,
      onEdit: editBirthdayMutation.mutateAsync,
    })
  }, [editBirthdayMutation.mutateAsync])

  return (
    <IconButton
      icon={EditIcon}
      onClick={handleDialogOpen}
      className="text-primary-500"
    />
  )
}
